// extracted by mini-css-extract-plugin
module.exports = {"container":"optionsSection_container__Tjfvf","selectContainer":"optionsSection_selectContainer__F_RSz","containerExtended":"optionsSection_containerExtended__1IP6Q","imgMobile":"optionsSection_imgMobile__37vYr","contentImg":"optionsSection_contentImg__19O-e"};
    if(module.hot) {
      // 1790670314829
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  